import { registerTour } from '@/features/tours';
import { FEATURE_FLAGS } from '@/features/featureFlags';

export const DAILY_LOG_TOUR_ID = 'daily-log.intro';

registerTour({
  id: DAILY_LOG_TOUR_ID,
  name: 'Daily Log',
  version: 1,
  featureFlagKey: FEATURE_FLAGS.DAILY_LOG.id,
  steps: [
    {
      id: 'welcome',
      title: 'Welcome to the Daily Log',
      body:
        'Capture what happened on site each day — manpower hours by ' +
        'subcontractor, plus a running notes section for everything else ' +
        '(weather, deliveries, delays, visitors, anything worth recording).',
    },
    {
      id: 'date-nav',
      target: '[data-tour-id="daily-log-date-nav"]',
      placement: 'left',
      spotlightPadding: 4,
      title: 'Pick a date',
      body:
        'Jump to any day with the date picker, or step backwards/forwards ' +
        'one day at a time with the arrows.',
    },
    {
      id: 'manpower',
      target: '[data-tour-id="daily-log-manpower"]',
      placement: 'top',
      spotlightPadding: 4,
      title: 'Manpower',
      body:
        'Log how many workers each subcontractor had on site and how many ' +
        'hours they put in. Totals roll up automatically.',
    },
    {
      id: 'notes',
      target: '[data-tour-id="daily-log-notes"]',
      placement: 'top',
      spotlightPadding: 4,
      title: 'Notes',
      body:
        'Write up everything else worth knowing about the day — and attach ' +
        'photos or files to back it up.',
    },
  ],
});
